import { Trans, useTranslation } from "next-i18next";
import React from "react";

export const Web_subscription_change_description = () => {
  const { t } = useTranslation("translations");
  return (
    <Trans
      i18nKey={
        t
          ? t("web_subscription_change_description")
          : "web_subscription_change_description"
      }
      components={{
        bold: <strong />,
      }}
    />
  );
};
